import React, { ReactNode } from 'react'
import OpenOutlookIcon from '../../../assets/icons/OpenOutlookIcon'
import {
    AuthVerificationCard,
    AuthVerificationCardInner,
    EmailClientButtons,
    EmailClientButton,
    AuthResendLink,
} from '../authFormCommon'

interface ICheckInboxCardProps {
    loading?: boolean
    onResend?: () => void
    footer?: ReactNode
    resendPosition?: 'top' | 'bottom'
    resendButtonStyle?: 'link' | 'outline'
}

const CheckInboxCard: React.FC<ICheckInboxCardProps> = ({
    loading = false,
    onResend,
    footer,
    resendPosition = 'bottom',
    resendButtonStyle = 'link',
}) => {
    const resendButton =
        onResend &&
        (resendButtonStyle === 'outline' ? (
            <EmailClientButton type="button" disabled={loading} onClick={onResend}>
                Resend verification link
            </EmailClientButton>
        ) : (
            <AuthResendLink type="button" disabled={loading} onClick={onResend}>
                Resend verification link
            </AuthResendLink>
        ))

    return (
        <AuthVerificationCard>
            <AuthVerificationCardInner>
                <EmailClientButtons>
                    {resendPosition === 'top' && resendButton}
                    <EmailClientButton
                        type="button"
                        onClick={() => window.open('https://mail.google.com/mail/u/0/#inbox', '_blank')}
                    >
                        <GmailIcon />
                        <span>Open Gmail</span>
                    </EmailClientButton>
                    <EmailClientButton
                        type="button"
                        onClick={() => window.open('https://outlook.live.com/mail/0/inbox', '_blank')}
                    >
                        <OpenOutlookIcon />
                        <span>Open Outlook</span>
                    </EmailClientButton>
                </EmailClientButtons>
                {resendPosition === 'bottom' && resendButton}
                {footer}
            </AuthVerificationCardInner>
        </AuthVerificationCard>
    )
}

export default CheckInboxCard

const GmailIcon = () => (
    <svg width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
        <path d="M19.6 10.23c0-.68-.06-1.36-.18-2H10v3.79h5.48a4.68 4.68 0 01-2.03 3.07v2.55h3.28c1.92-1.77 3.03-4.38 3.03-7.41z" fill="#4285F4"/>
        <path d="M10 20c2.7 0 4.97-.89 6.63-2.41l-3.28-2.55c-.91.61-2.07.97-3.35.97-2.57 0-4.75-1.74-5.53-4.07H1.08v2.6A9.99 9.99 0 0010 20z" fill="#34A853"/>
        <path d="M4.47 11.94A5.99 5.99 0 014.13 10c0-.67.12-1.32.34-1.94V5.46H1.08A9.99 9.99 0 000 10c0 1.64.39 3.19 1.08 4.54l3.39-2.6z" fill="#FBBC05"/>
        <path d="M10 4.01c1.47 0 2.78.51 3.81 1.51l2.85-2.85C14.97 1.13 12.7.01 10 .01A9.99 9.99 0 001.08 5.46l3.39 2.6C5.25 5.75 7.43 4.01 10 4.01z" fill="#EA4335"/>
    </svg>
)
